module.exports = __webpack_public_path__ + "img/southampton.650ff6d8.png";